<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Name:</label>
          </b-col>
          <b-col sm="12">
            <b-form-input id="input-small" v-model="name" size="sm" placeholder="Enter your name"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Description:</label>
          </b-col>
          <b-col sm="12">
            <b-form-textarea id="input-small" v-model="description" size="sm" placeholder="Enter your description"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="my-1 mt-2">
          <b-col sm="12">
            <b-button @click="saveBrand" class="btn btn-success">Submit</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {BrandsPath} from "../../../../path";

export default {
  name: "add",
  props : ['selectedBrand'],
  data(){
    return {
      name : '',
      description : '',
      baseUrl : process.env.VUE_APP_API_BACKEND_URL
    }
  },
  watch : {
    selectedBrand(v){
        console.log(v);
        this.name = this.selectedBrand.name;
        this.description = this.selectedBrand.description;
        this.sort_order = this.selectedBrand.sort_order;
    }
  },
  mounted() {
    this.name = this.selectedBrand.name;
    this.description = this.selectedBrand.description;
    this.sort_order = this.selectedBrand.sort_order;
  },
  methods : {
    async saveBrand(){
      try {
        let res;
        if(Object.keys(this.selectedBrand).length > 0){
          res = await axios.put(this.baseUrl + (this.selectedBrand ? (BrandsPath.BASIC_BRAND + '/' + this.selectedBrand.id) : BrandsPath.BASIC_BRAND),{
            name : this.name,
            description : this.description,
          });
        }else{
          res = await axios.post(this.baseUrl + BrandsPath.BASIC_BRAND,{
            name : this.name,
            description : this.description,
          });
        }

        console.log(res);
        if(res.data.status == true)
        {
          this.$bvToast.toast('Successfully added', {
            title: `Brand added`,
            variant: 'success',
            solid: true
          });
          this.$bvModal.hide("bv-add-brand");
          this.$emit("update");
        }
      }catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>